import { RefObject, useCallback, useLayoutEffect } from 'react';

export function useFocusElement(
  containerId: string,
  htmlTag: keyof HTMLElementTagNameMap,
  options: { preventScroll?: boolean } = {}
) {
  const { preventScroll = false } = options;
  useLayoutEffect(() => {
    document
      .getElementById(containerId)
      ?.querySelector<HTMLInputElement>(`${htmlTag}:not(:disabled)`)
      ?.focus({ preventScroll });
  }, [containerId, htmlTag, preventScroll]);
}

export function useFocusElement2(
  ref: RefObject<HTMLElement | null>,
  htmlTag: keyof HTMLElementTagNameMap,
  options: { preventScroll?: boolean } = {}
) {
  const { preventScroll = false } = options;
  useLayoutEffect(() => {
    ref.current?.querySelector<HTMLInputElement>(`${htmlTag}:not(:disabled)`)?.focus({ preventScroll });
  }, [ref, htmlTag, preventScroll]);
}

export function useFocusCallback() {
  return useCallback(
    (containerId: string, htmlTag: keyof HTMLElementTagNameMap) =>
      document
        .getElementById(containerId)
        ?.querySelector<HTMLInputElement>(`${htmlTag}:not(:disabled)`)
        ?.focus(),
    []
  );
}
